(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/casino-react/filter-and-sort/assets/javascripts/components/sort.js') >= 0) return;  svs.modules.push('/components/casino-react/filter-and-sort/assets/javascripts/components/sort.js');
"use strict";

const _React = React,
  useEffect = _React.useEffect,
  useMemo = _React.useMemo,
  useCallback = _React.useCallback;
const _svs$ui$ReactAccordio = svs.ui.ReactAccordion,
  Accordion = _svs$ui$ReactAccordio.Accordion,
  AccordionItem = _svs$ui$ReactAccordio.AccordionItem,
  AccordionSummary = _svs$ui$ReactAccordio.AccordionSummary,
  AccordionDetails = _svs$ui$ReactAccordio.AccordionDetails;
const _svs$components$casin = svs.components.casino_react.hooks,
  useSetSearchParams = _svs$components$casin.useSetSearchParams,
  useSearchParams = _svs$components$casin.useSearchParams;
const SortOption = svs.components.casino_react.filterAndSort.components.SortOption;
const sortingOptions = svs.components.casino_react.common.utils.getSortingOptions();
const Sort = () => {
  const _useSearchParams = useSearchParams(),
    sortingFromQueryParam = _useSearchParams.sorting;
  const _useSetSearchParams = useSetSearchParams(),
    setSorting = _useSetSearchParams.setSorting;
  const activeSorting = useMemo(() => {
    var _sortingOptions$find;
    const sorting = (_sortingOptions$find = sortingOptions.find(sortingOption => sortingOption.mode === sortingFromQueryParam)) !== null && _sortingOptions$find !== void 0 ? _sortingOptions$find : sortingOptions[0];
    return sorting;
  }, [sortingFromQueryParam]);
  const onSortingClick = useCallback(clickedSortingOption => {
    if (clickedSortingOption.mode.includes('default')) {
      setSorting('');
    } else {
      setSorting(clickedSortingOption.mode);
    }
  }, [setSorting]);
  useEffect(() => {
    if (sortingFromQueryParam && !activeSorting) {
      setSorting('');
    }
  }, [sortingFromQueryParam, activeSorting, setSorting]);
  return React.createElement("div", {
    className: "casino-filter-and-sort__sort-options"
  }, React.createElement(Accordion, {
    branding: "inverted",
    customer: "sport",
    isFlat: true
  }, React.createElement(AccordionItem, null, React.createElement(AccordionSummary, null, "Sortera: ".concat(activeSorting.name)), React.createElement(AccordionDetails, null, React.createElement("ul", {
    className: "sort-list"
  }, sortingOptions.map(sortingOption => React.createElement(SortOption, {
    isChecked: activeSorting.mode === sortingOption.mode,
    key: sortingOption.name,
    onClickCallback: onSortingClick,
    sortingOption: sortingOption
  })))))));
};
setGlobal('svs.components.casino_react.filterAndSort.components.Sort', Sort);

 })(window);